import { ExamType } from "@tsin-core/entities";
import { IExam, IExamCreate, IExamPool } from "@tsin-core/models/exam.model";

// store/actions/exam.actions.ts
export class GetExams {
  static readonly type = '[Exam] Get Exams';
  constructor(public examType: ExamType, public time: 'upcoming' | 'past' | 'all') { }
}

export class GetExamById {
  static readonly type = '[Exam] Get Single Exam';
  constructor(public examId: string) { }
}


export class AddExam {
  static readonly type = '[Exam] Add Exam';
  constructor(public payload: IExamCreate) { }
}

export class UpdateExam {
  static readonly type = '[Exam] Update Exam';
  constructor(public payload: IExamCreate) { }
}

export class DeleteExam {
  static readonly type = '[Exam] Delete Exam';
  constructor(public id: string) { }
}

export class GetExamGuests {
  static readonly type = '[Exam] Get Exam Guests';
  constructor(public type?: ExamType) { }
}

export class GetAllNotRegistered {
  static readonly type = '[Exam] Get All Not Registered';
  constructor() { }
}
